import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// src/index.ts
import equal2 from "@gilbarbara/deep-equal";
import is2 from "is-lite"; // src/helpers.ts

import equal from "@gilbarbara/deep-equal";
import is from "is-lite";

function canHaveLength() {
  for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
    arguments_[_key] = arguments[_key];
  }

  return arguments_.every(function (d) {
    return is.string(d) || is.array(d) || is.plainObject(d);
  });
}

function checkEquality(left, right, value) {
  if (!isSameType(left, right)) {
    return false;
  }

  if ([left, right].every(is.array)) {
    return !left.some(hasValue(value)) && right.some(hasValue(value));
  }

  if ([left, right].every(is.plainObject)) {
    return !Object.entries(left).some(hasEntry(value)) && Object.entries(right).some(hasEntry(value));
  }

  return right === value;
}

function compareNumbers(previousData, data, options) {
  var actual = options.actual,
      key = options.key,
      previous = options.previous,
      type = options.type;
  var left = nested(previousData, key);
  var right = nested(data, key);
  var changed = [left, right].every(is.number) && (type === "increased" ? left < right : left > right);

  if (!is.undefined(actual)) {
    changed = changed && right === actual;
  }

  if (!is.undefined(previous)) {
    changed = changed && left === previous;
  }

  return changed;
}

function compareValues(previousData, data, options) {
  var key = options.key,
      type = options.type,
      value = options.value;
  var left = nested(previousData, key);
  var right = nested(data, key);
  var primary = type === "added" ? left : right;
  var secondary = type === "added" ? right : left;

  if (!is.nullOrUndefined(value)) {
    if (is.defined(primary)) {
      if (is.array(primary) || is.plainObject(primary)) {
        return checkEquality(primary, secondary, value);
      }
    } else {
      return equal(secondary, value);
    }

    return false;
  }

  if ([left, right].every(is.array)) {
    return !secondary.every(isEqualPredicate(primary));
  }

  if ([left, right].every(is.plainObject)) {
    return hasExtraKeys(Object.keys(primary), Object.keys(secondary));
  }

  return ![left, right].every(function (d) {
    return is.primitive(d) && is.defined(d);
  }) && (type === "added" ? !is.defined(left) && is.defined(right) : is.defined(left) && !is.defined(right));
}

function getIterables(previousData, data) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      key = _ref.key;

  var left = nested(previousData, key);
  var right = nested(data, key);

  if (!isSameType(left, right)) {
    throw new TypeError("Inputs have different types");
  }

  if (!canHaveLength(left, right)) {
    throw new TypeError("Inputs don't have length");
  }

  if ([left, right].every(is.plainObject)) {
    left = Object.keys(left);
    right = Object.keys(right);
  }

  return [left, right];
}

function hasEntry(input) {
  return function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    if (is.array(input)) {
      return equal(input, value) || input.some(function (d) {
        return equal(d, value) || is.array(value) && isEqualPredicate(value)(d);
      });
    }

    if (is.plainObject(input) && input[key]) {
      return !!input[key] && equal(input[key], value);
    }

    return equal(input, value);
  };
}

function hasExtraKeys(left, right) {
  return right.some(function (d) {
    return !left.includes(d);
  });
}

function hasValue(input) {
  return function (value) {
    if (is.array(input)) {
      return input.some(function (d) {
        return equal(d, value) || is.array(value) && isEqualPredicate(value)(d);
      });
    }

    return equal(input, value);
  };
}

function includesOrEqualsTo(previousValue, value) {
  return is.array(previousValue) ? previousValue.some(function (d) {
    return equal(d, value);
  }) : equal(previousValue, value);
}

function isEqualPredicate(data) {
  return function (value) {
    return data.some(function (d) {
      return equal(d, value);
    });
  };
}

function isSameType() {
  for (var _len2 = arguments.length, arguments_ = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    arguments_[_key2] = arguments[_key2];
  }

  return arguments_.every(is.array) || arguments_.every(is.number) || arguments_.every(is.plainObject) || arguments_.every(is.string);
}

function nested(data, property) {
  if (is.plainObject(data) || is.array(data)) {
    if (is.string(property)) {
      var props = property.split(".");
      return props.reduce(function (acc, d) {
        return acc && acc[d];
      }, data);
    }

    if (is.number(property)) {
      return data[property];
    }

    return data;
  }

  return data;
} // src/index.ts


function treeChanges(previousData, data) {
  if ([previousData, data].some(is2.nullOrUndefined)) {
    throw new Error("Missing required parameters");
  }

  if (![previousData, data].every(function (d) {
    return is2.plainObject(d) || is2.array(d);
  })) {
    throw new Error("Expected plain objects or array");
  }

  var added = function added(key, value) {
    try {
      return compareValues(previousData, data, {
        key: key,
        type: "added",
        value: value
      });
    } catch (_unused) {
      return false;
    }
  };

  var changed = function changed(key, actual, previous) {
    try {
      var left = nested(previousData, key);
      var right = nested(data, key);
      var hasActual = is2.defined(actual);
      var hasPrevious = is2.defined(previous);

      if (hasActual || hasPrevious) {
        var leftComparator = hasPrevious ? includesOrEqualsTo(previous, left) : !includesOrEqualsTo(actual, left);
        var rightComparator = includesOrEqualsTo(actual, right);
        return leftComparator && rightComparator;
      }

      if ([left, right].every(is2.array) || [left, right].every(is2.plainObject)) {
        return !equal2(left, right);
      }

      return left !== right;
    } catch (_unused2) {
      return false;
    }
  };

  var changedFrom = function changedFrom(key, previous, actual) {
    if (!is2.defined(key)) {
      return false;
    }

    try {
      var left = nested(previousData, key);
      var right = nested(data, key);
      var hasActual = is2.defined(actual);
      return includesOrEqualsTo(previous, left) && (hasActual ? includesOrEqualsTo(actual, right) : !hasActual);
    } catch (_unused3) {
      return false;
    }
  };

  var decreased = function decreased(key, actual, previous) {
    if (!is2.defined(key)) {
      return false;
    }

    try {
      return compareNumbers(previousData, data, {
        key: key,
        actual: actual,
        previous: previous,
        type: "decreased"
      });
    } catch (_unused4) {
      return false;
    }
  };

  var emptied = function emptied(key) {
    try {
      var _getIterables = getIterables(previousData, data, {
        key: key
      }),
          _getIterables2 = _slicedToArray(_getIterables, 2),
          left = _getIterables2[0],
          right = _getIterables2[1];

      return !!left.length && !right.length;
    } catch (_unused5) {
      return false;
    }
  };

  var filled = function filled(key) {
    try {
      var _getIterables3 = getIterables(previousData, data, {
        key: key
      }),
          _getIterables4 = _slicedToArray(_getIterables3, 2),
          left = _getIterables4[0],
          right = _getIterables4[1];

      return !left.length && !!right.length;
    } catch (_unused6) {
      return false;
    }
  };

  var increased = function increased(key, actual, previous) {
    if (!is2.defined(key)) {
      return false;
    }

    try {
      return compareNumbers(previousData, data, {
        key: key,
        actual: actual,
        previous: previous,
        type: "increased"
      });
    } catch (_unused7) {
      return false;
    }
  };

  var removed = function removed(key, value) {
    try {
      return compareValues(previousData, data, {
        key: key,
        type: "removed",
        value: value
      });
    } catch (_unused8) {
      return false;
    }
  };

  return {
    added: added,
    changed: changed,
    changedFrom: changedFrom,
    decreased: decreased,
    emptied: emptied,
    filled: filled,
    increased: increased,
    removed: removed
  };
}

export { treeChanges as default };